import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useOutlinedSecondaryButtonStyles = makeStyles(({ palette }) =>
  createStyles({
    root: {
      color: palette.text.primary,
      fontWeight: 'bold',
    },
  })
);

export default useOutlinedSecondaryButtonStyles;
